import fetch from "auth/FetchInterceptor";
const DashboardService = {};

const dashboardPrefix = "/dashboard";

DashboardService.getNumberOfStudentsBySchool = async (schoolId) =>
    await fetch(`${dashboardPrefix}/school/${schoolId}/getNumberOfStudents`, {
        method: "GET",
    });

DashboardService.getNumberOfInstructorsBySchool = async (schoolId) =>
    await fetch(`${dashboardPrefix}/school/${schoolId}/getNumberOfFormers`, {
        method: "GET",
    });

DashboardService.getNumberOfSchools = async () =>
    await fetch(`${dashboardPrefix}/getNumberOfSchools`, {
        method: "GET",
    });

DashboardService.getTrainingsTurnover = async () =>
    await fetch(`${dashboardPrefix}/getTrainingTurnover`, {
        method: "GET",
    });

DashboardService.getTrainingsTurnoverBySchool = async (schoolId) =>
    await fetch(`${dashboardPrefix}/school/${schoolId}/getTrainingTurnover`, {
        method: "GET",
    });

DashboardService.getSpendingRateBySchool = async (schoolId) =>
    await fetch(`${dashboardPrefix}/school/${schoolId}/getSpendingRate`, {
        method: "GET",
    });

DashboardService.getBestTrainings = async () =>
    await fetch(`${dashboardPrefix}/getTopFiveBestTrainings`, {
        method: "GET",
    });

DashboardService.getTheProfitRate = async ({ startDate, endDate }) =>
    await fetch(
        `${dashboardPrefix}/getTheProfitRate?startDate=${startDate}&endDate=${endDate}`,
        {
            method: "GET",
        }
    );

DashboardService.getSchoolsStats = async () =>
    await fetch(`${dashboardPrefix}/getNumberOfFormersAndStudents`, {
        method: "GET",
    });

DashboardService.getSpendingsAndRevenuesBySchool = async (schoolId) =>
    await fetch(
        `${dashboardPrefix}/school/${schoolId}/getSpendingRateAndTrainingTurnover`,
        {
            method: "GET",
        }
    );

export default DashboardService;
